export const title = 'Configuración de entradas';
export const dailyCapacity = 'Capacidad diaria de visitas';
export const subtitle = 'Entradas';
export const createButton = 'Crear nueva entrada';
export const editButton = 'Editar';
export const editTitle = 'Editar entrada';
export const uploadImages = 'Agregar imágenes';
export const parkCapacityUpdated = 'Capacidad del parque actualizada';
export const parkCapacityError = 'Error al actualizar la capacidad del parque';
